import Language from './language/reducer';
import Auth from './auth/reducer';

export default {
  Language,
  Auth,
};
